import Link from 'carbon-components-react/lib/components/Link';
import Launch20 from '@carbon/icons-react/lib/launch/20';
import { withPrefix } from "gatsby";
import * as React from 'react';
export default {
  Link,
  Launch20,
  withPrefix,
  React
};